export enum StorageKey {
  ACCESS_TOKEN = 'accessToken',
}
